import React from 'react';
import tw, { css } from 'twin.macro'
import Layout from "../components/layout"
import { GatsbySeo, BreadcrumbJsonLd } from "gatsby-plugin-next-seo"
import { ReactComponent as Arrow } from '../images/arrow-green.svg'

// content01-card styles
const styles = {
    cardStyles: [
        tw`pt-10 md:pt-5 pb-14 md:pb-7 px-8 md:px-4 rounded-2xl transition-transform ease-linear hover:-translate-y-1 bg-white`,
        css`box-shadow: 0px 5px 16px rgba(0, 31, 49, 0.08)`
    ],
}

export default function Alternatives({ location }) {
    return (

        <Layout>
            <GatsbySeo
                canonical={location.href}
                title="CocoFax Alternatives: Find Out Why Teams Switch To CocoFax"
                description="Looking for an online fax alternative? Look no further than CocoFax. It is the best solution for your online faxing needs."
            />
            <BreadcrumbJsonLd
                itemListElements={[
                    {
                        position: 1,
                        name: 'Home',
                        item: process.env.REACT_APP_CONFIG_MAINURL,
                    },
                    {
                        position: 2,
                        name: 'Alternatives',
                        item: location.href,
                    },
                ]}
            />
            {/* head */}
            <section className='max-w-[1116px] mx-auto px-4'>
                <ul className="text-sm sm:text-xs pt-[10px] flex flex-wrap items-center leading-6">
                    <li><a href="/" target="_blank">Home</a> &nbsp;&gt;&nbsp;</li>
                    <li className='text-gray'>Alternatives</li>
                </ul>
                <div className="mx-auto flex justify-between items-center lg:flex-col mt-[34px] lg:mt-5 pb-20 lg:pb-10">
                    <div className='max-w-[580px] mx-auto'>
                        <h1 className="text-[40px] lg:text-[calc(18px+2vw)] font-black leading-snug text-center">Switch to CocoFax: An Unmatched Fax Alternative</h1>
                        <p className='text-sm text-gray-dark leading-6 text-center mt-6 lg:mt-3'>
                            Is your current online fax provider not delivering promised functionality, usability, and accessibility? CocoFax is here to save the day. It’s a top cloud-based fax solution that outshines other competitors. See for yourself.
                        </p>
                        <div className='relative max-w-[200px] mx-auto cursor-pointer mt-6 lg:mt-3'>
                            <div className='text-center bg-green hover:bg-hover-green text-white font-bold md:font-semibold rounded-full leading-[52px] px-5 md:px-2 block'>
                                <a href='https://cocofax.com/choose-fax-number.html#/' className='hover:text-white'>Start Faxing</a>
                            </div>
                            <p className='leading-8 text-xs text-center text-[#898C96]'>30-Day Money-Back Guarantee</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className='bg-[#EDFBF3]'>
                <div className='max-w-[1208px] px-4 mx-auto pt-20 lg:pt-10 pb-[126px] lg:pb-[63px]'>
                    <div className='mx-auto grid grid-cols-3 gap-x-9 gap-y-9 lg:gap-y-5 lg:w-full lg:grid-cols-2 md:grid-cols-1'>
                        <div css={[styles.cardStyles]}>
                            <h2 className='mt-2 text-xl md:text-[calc(14px+0.5vw)] font-bold text-center leading-tight'>
                                HelloFax
                            </h2>
                            <p className='mt-4 md:mt-2 text-sm leading-6 text-gray-dark'>
                                Wave goodbye to HelloFax, the poor player in your faxing game. You are worthy of a more feature-filled, secure alternative that scores high in customer satisfaction—CocoFax.
                            </p>
                            <a href="/hellofax-alternative.html" className="pt-4 flex items-center text-sm text-green hover:text-hover-green lg:justify-center leading-6">Learn more<Arrow width={24} /></a>
                        </div>
                        <div css={[styles.cardStyles]}>
                            <h2 className='mt-2 text-xl md:text-[calc(14px+0.5vw)] font-bold text-center leading-tight'>
                                MyFax
                            </h2>
                            <p className='mt-4 md:mt-2 text-sm leading-6 text-gray-dark'>
                                Still grin and bear MyFax's outdated, insufficient, and costly fax solution? Choose CocoFax instead to stay current and efficient in your daily fax workflows.
                            </p>
                            <a href="/myfax-alternative.html" className="pt-4 flex items-center text-sm text-green hover:text-hover-green lg:justify-center leading-6">Learn more<Arrow width={24} /></a>
                        </div>
                        <div css={[styles.cardStyles]}>
                            <h2 className='mt-2 text-xl md:text-[calc(14px+0.5vw)] font-bold text-center leading-tight'>
                                Nextiva vFax
                            </h2>
                            <p className='mt-4 md:mt-2 text-sm leading-6 text-gray-dark'>
                                A worthy alternative to Nextiva vFax for cloud-based faxing is CocoFax, easy and feature-laden. Go for it and you’re on a journey to mobility and productivity.
                            </p>
                            <a href="/nextiva-vfax-alternative.html" className="pt-4 flex items-center text-sm text-green hover:text-hover-green lg:justify-center leading-6">Learn more<Arrow width={24} /></a>
                        </div>
                        <div css={[styles.cardStyles]}>
                            <h2 className='mt-2 text-xl md:text-[calc(14px+0.5vw)] font-bold text-center leading-tight'>
                                eFax
                            </h2>
                            <p className='mt-4 md:mt-2 text-sm leading-6 text-gray-dark'>
                                Swap eFax for CocoFax to experience truly advanced fax functionality, reasonable pricing, white-glove customer care, and greater usability.
                            </p>
                            <a href="/efax-alternative.html" className="pt-4 flex items-center text-sm text-green hover:text-hover-green lg:justify-center leading-6">Learn more<Arrow width={24} /></a>
                        </div>
                        <div css={[styles.cardStyles]}>
                            <h2 className='mt-2 text-xl md:text-[calc(14px+0.5vw)] font-bold text-center leading-tight'>
                                RingCentral Fax
                            </h2>
                            <p className='mt-4 md:mt-2 text-sm leading-6 text-gray-dark'>
                                What makes CocoFax unique compared to RingCentral is its ability to provide dedicated, all-around, fax-oriented services, with no bells and whistles.
                            </p>
                            <a href="/ringcentral-alternative.html" className="pt-4 flex items-center text-sm text-green hover:text-hover-green lg:justify-center leading-6">Learn more<Arrow width={24} /></a>
                        </div>
                    </div>
                </div >
            </section>

        </Layout >
    )
}